import { render, staticRenderFns } from "./DetailedPricingRailing.vue?vue&type=template&id=80087ed8&scoped=true"
import script from "./DetailedPricingRailing.vue?vue&type=script&lang=js"
export * from "./DetailedPricingRailing.vue?vue&type=script&lang=js"
import style0 from "./DetailedPricingRailing.vue?vue&type=style&index=0&id=80087ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80087ed8",
  null
  
)

export default component.exports